import { render, staticRenderFns } from "./ShopProductsList.vue?vue&type=template&id=01290f9c&scoped=true&"
import script from "./ShopProductsList.vue?vue&type=script&lang=js&"
export * from "./ShopProductsList.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductsList.vue?vue&type=style&index=0&id=01290f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01290f9c",
  null
  
)

export default component.exports